/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'update': {
    width: 10,
    height: 11,
    viewBox: '0 0 10 11',
    data: '<g _fill="#376F99" fill-rule="nonzero"><path pid="0" d="M6.754 2.536h1.8v1h-2.3a.5.5 0 0 1-.5-.5v-2.3h1v1.8zM7.11 6.283v1H2.928v-1zM7.11 4.41v1H2.928v-1zM4.5 2.536v1H2.927v-1z"/><path pid="1" d="M7.583 9.581l.47-.494V2.503L6.772 1.237h-4.8v7.767l.502.534L3.72 8.204l1.286 1.374 1.286-1.374 1.29 1.377zm-3.862.086L2.475 11 .97 9.4V1.072c0-.456.368-.835.828-.835h5.089c.24 0 .375.08.54.242l1.38 1.362a.755.755 0 0 1 .247.562v7.084l-1.478 1.55-1.283-1.37-1.286 1.374-1.286-1.374z"/></g>'
  }
})
